const Opid = () => {
  // let params = useParams();
  return <div>{/* {<h4 className="px-3 mb-3 text-center">Status {params.tag}</h4>} */}</div>;
};

export default Opid;
